import script from "./RogainingView.vue?vue&type=script&setup=true&lang=js"
export * from "./RogainingView.vue?vue&type=script&setup=true&lang=js"

import "./RogainingView.vue?vue&type=style&index=0&id=2273e3d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2273e3d2"]])

export default __exports__